// Function to change h1 to h2
function changeH1ToH2() {
    const currentURL = window.location.href;
    const urlsToChange = [
        'https://www.sprocketroasters.com.au/collections/decafinated',
        'https://www.sprocketroasters.com.au/collections/fairtrade-organic',
        'https://www.sprocketroasters.com.au/collections/roast-level-light',
        'https://www.sprocketroasters.com.au/collections/roast-level-medium',
        'https://www.sprocketroasters.com.au/collections/roast-level-dark',
        'https://www.sprocketroasters.com.au/collections/caramel-flavour',
        'https://www.sprocketroasters.com.au/collections/chocolate-flavour',
        'https://www.sprocketroasters.com.au/collections/fruit-flavour',
        'https://www.sprocketroasters.com.au/collections/floral-flavour',
        'https://www.sprocketroasters.com.au/collections/toasted-nuts-flavour'
    ];

    // Function to perform the h1 to h2 change
    function performChange(element) {
        if (element) {
            const h2Element = document.createElement('h2');
            
            // Copy attributes from h1 to h2
            for (let i = 0; i < element.attributes.length; i++) {
                const attr = element.attributes[i];
                h2Element.setAttribute(attr.name, attr.value);
            }
            
            // Copy content from h1 to h2
            h2Element.innerHTML = element.innerHTML;
            
            // Replace h1 with h2
            element.parentNode.replaceChild(h2Element, element);
        }
    }

    // Check for collection pages
    if (urlsToChange.includes(currentURL)) {
        const h1Element = document.querySelector('h1.h0');
        performChange(h1Element);
    }

    // Check for product page (Decaf Coffee)
    if (currentURL === 'https://www.sprocketroasters.com.au/products/decaf-coffee') {
        const productH1 = document.querySelector('h1.product-info__title.h2');
        performChange(productH1);
    }
}

// Run the function immediately
changeH1ToH2();